import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7097300a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "card-icon" }, null, -1))
const _hoisted_3 = { class: "card-content" }
const _hoisted_4 = { class: "card-item-icon" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "card-info" }
const _hoisted_7 = { class: "card-label" }
const _hoisted_8 = {
  key: 0,
  class: "card-value"
}
const _hoisted_9 = { class: "card-num" }
const _hoisted_10 = { class: "card-unit" }
const _hoisted_11 = {
  key: 1,
  class: "card-value"
}
const _hoisted_12 = { class: "card-num" }
const _hoisted_13 = { class: "card-unit" }


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberCard',
  props: {
    title: {},
    cards: {}
  },
  setup(__props: any) {


const props = __props;


return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "card-item",
            key: index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: item.icon,
                alt: ""
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.label), 1),
              (item.format)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.format(item.num), (i, key) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(i), 1),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(key), 1)
                      ], 64))
                    }), 256))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(item.num), 1),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(item.unit), 1)
                  ]))
            ])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})